export enum DnsVerificationStatus {
  Passed = 'PASSED',
  Failed = 'FAILED',
}

export class DnsVerification {
  public verificationCode: string;
  public status: DnsVerificationStatus;

  constructor(backEndVerification?: BackEndDnsVerification) {
    if (backEndVerification) {
      this.verificationCode = backEndVerification.verification_code;
      this.status = backEndVerification.status;
    }
  }

  public toBackEnd(): BackEndDnsVerification {
    return {
      verification_code: this.verificationCode,
      status: this.status,
    };
  }
}

export interface BackEndDnsVerification {
  verification_code: string;
  status: DnsVerificationStatus;
}
